export const ADD_HIERARCHICAL_CATEGORIES = 'ADD_HIERARCHICAL_CATEGORIES'
export const FOCUS_CATEGORY = 'FOCUS_CATEGORY'
export const EXPAND_CATEGORY = 'EXPAND_CATEGORY'
export const COLLAPSE_CATEGORY = 'COLLAPSE_CATEGORY'
export const SET_LOAD_STATUS = 'SET_LOAD_STATUS'
export const SET_CATEGORY_FOR_EDIT = 'SET_CATEGORY_FOR_EDIT'
export const CLEAR_CATEGORY_FOR_EDIT = 'CLEAR_CATEGORY_FOR_EDIT'
export const SET_POPULARITY_MAP = 'SET_POPULARITY_MAP'
